module.exports = __webpack_public_path__ + "static/media/bikesha_bugesera4.bfef5f43.jpeg";